var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"component-product",style:(`flex-direction:${
      _vm.showTitleOnTop ? 'column-reverse;' : 'column;'
    } `)},[_c('img',{style:(`border-radius:${_vm.borderRadius}; width:100%;height:${_vm.height};`),attrs:{"src":_vm.imgUrl,"alt":"","oncontextmenu":"return false"}}),_c('span',[_vm._v(_vm._s(_vm.productName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }